<template>
    <div>
        <div class="container-wrapper">
            <div class="main-back">
                <button class="btn--back" @click.prevent="routerBack">Back</button>
            </div>
            <div class="container-content">
                <div class="project-info--title">
                    <h1>{{item.title}}</h1>
                </div>
                <div class="project-info--top">
                    <div class="project-info--left">
                        <!-- <GalleryMain :galleryMain="gallery" :css-class="`project-gallery--main`"></GalleryMain> -->
                    </div>
                    <div class="project-info--right">
                        <dl class="project-info--info">
                            <dt>Date:</dt>
                            <dd><span class="text">{{item.published}}</span></dd>
                            <dt>Type:</dt>
                            <dd>
                                <div class="badge--wrapper">
                                    <span class="badge" v-for="v in item.types">{{v}}</span>
                                </div>
                            </dd>
                            <dt>Category:</dt>
                            <dd>
                                <div class="badge--wrapper">
                                    <span class="badge" v-for="v in item.categories">{{v}}</span>
                                </div>
                            </dd>
                            <dt>Technologies</dt>
                            <dd>
                                <div class="badge--wrapper">
                                    <span class="badge" v-for="v in item.technologies">{{v}}</span>
                                </div>
                            </dd>
                        </dl>
                        <div class="project-info--bottom">
                            <!-- <GalleryNavigation :galleryNav="gallery" :css-class="`project-gallery--nav`"></GalleryNavigation> -->
                            <div class="project-info--badge">
                                <div class="badge--wrapper">
                                    <span class="badge" v-for="v in item.tags">#{{v}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="project-info--content">
                    <h3>Overview</h3>
                    <div v-html="item.description" class="info-text"></div>
                </div>
                <template v-if="related.length">
                    <div>
                        <h3>Related Projects</h3>
                        <related-projects :related="related"></related-projects>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    // import GalleryNavigation from '../components/GalleryNavigation.vue';
    // import GalleryMain from '../components/GalleryMain.vue';
    import RelatedProjects from '../components/RelatedProjects.vue';
    export default {
        name: "Project",
        components: {
            // GalleryNavigation,
            // GalleryMain,
            RelatedProjects
        },
        created() {
            this.fetch(this.$route.params.slug);
        },
        destroyed() {
            this.resetState()
        },
        computed: {
            ...mapGetters('ProjectsSingle', ['item', 'loading', 'gallery', 'related', 'mainImage']),
        },
        watch: {
            "$route.params.slug": function() {
                this.resetState();
                this.fetch(this.$route.params.slug)
            }
        },
        methods: {
            ...mapActions('ProjectsSingle', ['fetch', 'resetState'])
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/pages/Project.vue